// Dependencies
import { FC, ReactElement } from "react";

// Styles
import { StyledItemLabel, StyledItemWrapper } from "./InfoItem.styled";

interface InfoItemProps {
  label: string;
  data: ReactElement;
}

const InfoItem: FC<InfoItemProps> = ({ label, data }) => {
  return (
    <StyledItemWrapper>
      <StyledItemLabel>{label}</StyledItemLabel>
      {data}
    </StyledItemWrapper>
  );
};

export default InfoItem;
